import * as React                          from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'

import Grid       from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { Experience }   from '../../api'
import { LabelledText } from '../atoms'

export default ({
  position,
  company,
  sector,
  start,
  end,
}: Experience) => (
  <Grid container spacing={40}>
    <Grid item xs={12}>
      <Typography variant={'headline'} color={'textPrimary'}>
        {position}
      </Typography>
      <Typography
        noWrap
        variant={'subheading'}
      >
        {company}
      </Typography>
    </Grid>
    <Grid item>
      <LabelledText label={<FormattedMessage id={'labels.from'} />}>
        <FormattedDate
          value={start}
          year={'numeric'}
          month={'2-digit'}
          day={'2-digit'}
        />
      </LabelledText>
    </Grid>
    <Grid item>
      <LabelledText label={<FormattedMessage id={'labels.to'} />}>
        <FormattedDate
          value={end}
          year={'numeric'}
          month={'2-digit'}
          day={'2-digit'}
        />
      </LabelledText>
    </Grid>
    <Grid item>
      <LabelledText label={<FormattedMessage id={'labels.sector'} />}>
        <FormattedMessage id={`sectors.${String(sector)}`}/>
      </LabelledText>
    </Grid>
  </Grid>
)



// WEBPACK FOOTER //
// ./src/components/molecules/ExperienceCard.tsx